import { Injectable } from '@angular/core';
// import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router'; // Simplified imports
// import { Observable } from 'rxjs'; // No longer needed for canLoad return type if only boolean
// import { AuthService } from '@services/auth.service'; // Removed
// import { CommonService } from '@services/common.service'; // Removed
// import { NgxUiLoaderService } from 'ngx-ui-loader'; // Removed
// import { map } from 'rxjs/operators'; // Removed
import {
  CanActivate,
  Router,
  // ActivatedRouteSnapshot, // No longer needed for canLoad if simplified
  // RouterStateSnapshot, // No longer needed for canLoad if simplified
  // UrlTree // No longer needed for canLoad if simplified
} from '@angular/router';
import { ToastDisplay } from '../toastr/toast-service';
import { UtilsHelper } from '../utils.helper';


@Injectable({
  providedIn: 'root',
})
export class DashboardAuthGuard implements CanActivate {
  constructor(
    private _router: Router,
    private toastr: ToastDisplay // ToastDisplay is kept for the error message
    // private activatedRoute: ActivatedRoute, // Removed
    // private authService: AuthService, // Removed
    // private loading: NgxUiLoaderService, // Removed
    // private commonService: CommonService // Removed
  ) { }

  canActivate(): boolean {
    if (UtilsHelper.IsLoggedIn) {
      console.log('DashboardAuthGuard: Logged in (canActivate)');
      return true;
    }
    console.log('DashboardAuthGuard: Not logged in, navigating to login (canActivate)');
    // Ensure token and auth params are cleared if navigating to login
    this._router.navigate(['/auth/login'], { queryParams: { token: null, auth: null }, replaceUrl: true });
    return false;
  }

  canLoad(): boolean { // Simplified to return boolean
    if (UtilsHelper.IsLoggedIn) {
      console.log('DashboardAuthGuard: Logged in (canLoad)');
      return true;
    }

    console.log('DashboardAuthGuard: Not logged in, navigating to login (canLoad)');
    if (!UtilsHelper.getObject('logout')) { // Keep toast, as per instruction "Optionally, show a toast message"
      this.toastr.showError('You are not logged in');
    }
    // Ensure token and auth params are cleared if navigating to login
    this._router.navigate(['/auth/login'], { queryParams: { token: null, auth: null }, replaceUrl: true });
    return false;
  }

  // tryLogin method completely removed
}